<template>
  <div
    class="v-context-menu__wrapper"
    :class="{
      ['active']: isActive,
      ['no-border']: !!noBorder,
      [type]: !!type
    }"
    @click="_activateMenu"
    ref="list"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="18"
      viewBox="0 0 4 18"
    >
      <g>
        <g>
          <path
            fill="#c4c4c4"
            d="M0 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
          />
        </g>
      </g>
    </svg>

    <div class="menu-wrapper" :class="{ [dpSize]: !!dpSize }">
      <ul>
        <li
          v-for="(action, idx) in actions"
          :key="idx"
          :class="{ [action.extraClass]: !!action.extraClass }"
          @mouseenter="currentActive = action.id"
          @mouseleave="currentActive = null"
          @click="e => action.handler(e, action)"
        >
          <div class="item-wrapper">
            <img
              v-if="action.iconSrc"
              :src="
                currentActive === action.id
                  ? action.iconSrcActive
                  : action.iconSrc
              "
              alt="icon"
            />
            <i v-else-if="action.icon" :class="`fa fa-${action.icon}`"> </i>
            <div class="summary">
              <span class="title"> {{ action.title }} </span>
              <div class="description" v-if="action.description">
                {{ action.description }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VContextMenu", {
  props: {
    actions: VueTypes.arrayOf(VueTypes.object),
    noBorder: VueTypes.bool.def(false),

    // affect on visuals
    type: VueTypes.oneOf(["round", "classic"]).def("round"),

    // dropdown menu size
    dpSize: VueTypes.oneOf(["wide", "narrow"]).def("narrow")
  },

  data() {
    return {
      isActive: false,
      currentActive: null,
      iconHovered: false
    };
  },

  methods: {
    _deactivateMenu(e) {
      if (!this.isActive) {
        return;
      }

      const listEl = this.$refs.list;
      const target = e.target;

      if (listEl && listEl !== target && !listEl.contains(target)) {
        this.isActive = false;
      }
    },

    _activateMenu(e) {
      e.stopPropagation();
      this.isActive = !this.isActive;
    }
  },

  created() {
    document.addEventListener("click", e => this._deactivateMenu(e), true);
  },

  beforeDestroy() {
    document.removeEventListener("click", e => this._deactivateMenu(e), true);
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-context-menu";

.#{$ns} {
  &__wrapper {
    /*max-width: 30px;*/
    max-height: 32px;
    position: relative;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.15s linear;
    width: 30px;
    height: $input-height;

    path {
      transition: fill 0.1s linear;
    }

    &:hover,
    &.active {
      path {
        fill: $primary-color !important;
      }
    }

    &.active {
      .menu-wrapper {
        display: block;
      }
    }

    &.no-border {
      &:hover,
      &.active {
        border-color: transparent;
        background: transparent;

        path {
          fill: $primary-color !important;
        }
      }
    }
    &.round {
      border-radius: 0;

      &:hover,
      .active {
        border-radius: 0;
      }

      .menu-wrapper {
        top: 30px;
        right: 30px;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2),
          0 0 0 1px rgba(0, 0, 0, 0.05);
        border: 0;
        min-width: 350px;
      }

      ul {
        max-width: 100%;
        overflow: auto;
        padding: 9px 0;

        li {
          padding: 6px 12px;
          font-weight: 500;
          border-top: 1px #fff;
          border-bottom: 1px #fff;
          text-decoration: none;

          .item-wrapper {
            display: flex;
            align-items: center;

            i {
              margin-right: 10px;
            }

            img {
              margin-right: 5px;
            }
          }

          .summary {
            .title {
              font-size: 12px;
              font-family: "Lato-Medium", Arial, sans-serif;
              font-weight: 500;
              display: inline-block;
            }

            .description {
              font-size: 13px;
              line-height: 20px;
              color: #737376;
              font-weight: 400;
              margin-top: 5px;
            }
          }

          &:hover {
            .summary .description {
              color: $white;
            }
          }
        }
      }
    }

    .menu-wrapper {
      display: none;
      position: absolute;
      top: 33px;
      right: 0;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.17);
      background: $white;
      z-index: 9999;

      li {
        font-size: 15px;
        padding: 10px 15px;

        &:hover {
          color: $primary-color;
        }
      }

      &.narrow {
        width: 125px;
        min-width: auto;
        border-radius: 5px;
      }

      &.wide {
        width: 135px;
      }
    }
  }
}
</style>
